var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_c('transition',{attrs:{"name":_vm.isWithoutTransition ? '' : 'content'}},[(_vm.isVisible)?_c('div',{staticClass:"accordion-content"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }